<template>
  <div class="salePrice-content" :class="{ 'has-crossprice': hasCrossPrice }">
    <div class="crossprice d-block" v-if="showCrossPrice && hasCrossPrice" :class="{ 'is-special-offer': hasSpecialOffer }">
      <template v-if="hasSpecialOffer">
        <del class="text-muted small text-appearance">{{ currentVariation.prices.default.unitPrice.formatted | itemCrossPrice(true) }}</del>
      </template>
      <template v-else>
        <del class="text-muted small text-appearance">{{ currentVariation.prices.rrp.unitPrice.formatted }}</del> {{ $translate("ETCeresCoconut::Template.singleItemUVP") }}
      </template>
    </div>
    <div class="salePrice d-flex">
      <div class="CrosspriceDiscount"  v-if="showCrossPrice && hasCrossPrice" :class="{ 'is-special-offer': hasSpecialOffer }">
        {{ (1 - (currentVariation.prices.default.unitPrice.value / currentVariation.prices.rrp.unitPrice.value))*-100 | numberFormat(0) }}%
      </div>
      <div class="price h1" :class="{ 'is-special-offer': hasSpecialOffer }">
        <div class="saleFont">
          <template v-if="showDynamicPrice">
            {{ $translate("Ceres::Template.dynamicVariationPrice",
              {
                price: $options.filters.currency(variationTotalPrice, currentVariation.prices.default.currency)
              }
          ) }}
          </template>

          <template v-else>
            {{ variationTotalPrice | currency(currentVariation.prices.default.currency) }}
          </template>
        </div>
        <div class="saleInfo">
          {{ $translate("Ceres::Template.itemInclVAT") }}
        {{ $translate("Ceres::Template.itemExclusive") }}
          <span class="openShippingCostsWrapper" style="cursor: pointer;">{{ $translate("Ceres::Template.itemShippingCosts") }}</span>
        </div>
      </div>

    </div>
    <graduated-prices class="mt-2"></graduated-prices>
    <div class="unitPrice">
      <!-- class .is-single-piece is added for customers to hide the unit if it is C62 -->
      <div class="base-price text-muted"
           v-if="currentVariation.unit"
           :class="{ 'is-single-piece': currentVariation.unit && currentVariation.unit.content === 1 && currentVariation.unit.unitOfMeasurement === 'C62' }">
        <div v-if="currentVariation.variation.mayShowUnitPrice">
          {{ $translate("Ceres::Template.singleItemUnitPrice") }}
          <span class="base-price-value">
                        {{ variationGraduatedPrice.basePrice | specialOffer(currentVariation.prices, "basePrice") }}
                    </span>
        </div>
      </div>
    </div>
    <template v-if="currentVariation.variationProperties">
      <template v-for="variation in currentVariation.variationProperties">
        <template v-for="properties in variation.properties">
          <template v-if="properties.id == 414">
            <div class="advertising" v-html="variation.properties[0].values.description">

            </div>
          </template>
        </template>
      </template>
    </template>
  </div>
</template>

<script>
import { hasVat } from "../../helper/OrderPropertyHelper";
export default {
    name: "item-price",

    props:
    {
        showCrossPrice:
        {
            type: Boolean,
            default: true
        }
    },

    inject: {
        itemId: {
            default: null
        }
    },

    computed:
    {
        currentVariation() {
            return this.$store.getters[`${this.itemId}/currentItemVariation`]
        },

        hasCrossPrice() {
            const hasRrpPrice = !!this.currentVariation.prices.rrp &&
                this.currentVariation.prices.rrp.unitPrice.value > this.currentVariation.prices.default.unitPrice.value;

            const hasBeforePrice = this.hasSpecialOffer &&
                !!this.currentVariation.prices.default &&
                this.currentVariation.prices.default.unitPrice.value > this.currentVariation.prices.specialOffer.unitPrice.value;

            return hasRrpPrice || hasBeforePrice;
        },

        hasSpecialOffer() {
            return !!this.currentVariation.prices.specialOffer;
        },

        variationGraduatedPrice() {
            return this.$store.getters[`${this.itemId}/variationGraduatedPrice`];
        },

        variationTotalPrice() {
            return this.$store.getters[`${this.itemId}/variationTotalPrice`];
        },

        showDynamicPrice() {
            const state = this.$store.state.items[this.itemId];
            return App.config.item.showPleaseSelect && App.isCheapestSorting
                && (state.variationSelect && !state.variationSelect.isVariationSelected)
                && (state.pleaseSelectVariationId === this.currentVariation.variation.id
                    || state.pleaseSelectVariationId === 0);
        },

        propertiesWithAdditionalCostsVisible() {
            return this.currentVariation.properties.filter(entry => {
                const property = entry.property;
                return property && property.isShownAsAdditionalCosts && property.isShownOnItemPage
                    && ((!property.isOderProperty && !App.useVariationOrderProperties)
                    || this.isVariationOrderPropertyRequiredPreselected(property))


            });
        }
    },
    methods: {
        isVariationOrderPropertyRequiredPreselected(property) {
            return property.isRequired
                    && property.isPreSelected
                    && property.isOderProperty
                    && App.useVariationOrderProperties
        },

        hasTax(property)
        {
            return hasVat(property);
        }
    }
}
</script>
